
<modal
  :open="open"
  title="Set matches found"
  size="full"
  @close="handleClose"
>
  <template v-if="open && setMatchesList.length > 0">
    <h4 v-if="profileInfo">
      {{ profileSummary || '—' }}
    </h4>
    <p class="set-matches-intro">
      The following profiles in this set can be merged using the same mapping. Select which to merge and confirm.
    </p>

    <div class="set-matches-list">
      <div class="set-match-row set-match-row-select-all">
        <checkbox
          :value="allSetMatchesSelected"
          :label="allSetMatchesSelected ? 'Deselect all' : 'Select all'"
          class="set-match-checkbox"
          @input="toggleSelectAll"
        />
      </div>
      <profile-set-match-row
        v-for="(item, i) in setMatchesList"
        :key="`${item.numberSlug}-${i}`"
        :item="item"
        :selected="selectedIndices[i] === true"
        @toggle="setSelected(i, $event)"
      />
    </div>
  </template>

  <template v-if="open" #footer>
    <align justify="space-between">
      <btn
        kind="secondary"
        @click="handleClose"
      >
        Cancel
      </btn>
      <btn
        :loading="confirming"
        :disabled="!selectionStats.hasSelected"
        @click="confirmMerge"
      >
        Confirm merge {{ selectionStats.selectedCount }} selected
      </btn>
    </align>
  </template>
</modal>
